import "./datepicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
// import { AiOutlineCalendar } from "react-icons/all";

const CustomDatePicker = ({
  inputClassName,
  minimumDate,
  maximumDate,
  ...props
}) => {
  return (
    <div className="custom_datepicker_wrapper">
      <DatePicker
        colorPrimary="#1e5279"
        colorPrimaryLight="#1e5279"
        inputClassName={`${inputClassName} custom_datepicker`}
        minimumDate={minimumDate}
        maximumDate={maximumDate}
        locale={"fa"}
        calendarPopperPosition="bottom"
        calendarClassName="responsive-calendar"
        {...props}
      />
      {/* <AiOutlineCalendar fontSize={20} /> */}
    </div>
  );
};
export default CustomDatePicker;
